import { OptimizelyDecisionsParams } from 'lib/hooks/useOptimizelyDecisions';
import { OptimizelyDecisionsState } from 'redux-implementations/optimizelyDecisions';

// this will spread all of the decisions into the event data
export const optimizelyEventParams = (
  optimizelyDecisions?: OptimizelyDecisionsParams
): OptimizelyDecisionsState => {
  return {
    ...optimizelyDecisions,
  };
};
